import { createSlice } from '@reduxjs/toolkit';

import {
  addToCartFailed,
  addToCartStarted,
  addToCartSucceeded,
  flightTimeLoaded,
  initFailed,
  initFinished,
  initSucceeded,
} from '../../actions/comboSummaryActions';

// `initialized` is set by **both** `initFailed` and `initFinished`. That is load-bearing: the
// thunk has an early exit that dispatches `initFailed` and returns without ever reaching
// `initFinished`, and this is what still lifts the loader in that case.
const comboSummarySlice = createSlice({
  name: 'comboSummary',
  initialState: { initialized: false },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(initSucceeded, (state, action) => {
        state.selectedCombination = action.payload.selectedCombination;
      })
      .addCase(initFailed, (state) => {
        state.initialized = true;
      })
      .addCase(initFinished, (state) => {
        state.initialized = true;
      })
      // Reads through `selectedCombination.transport`, so it throws if the flight time arrives
      // before the summary does — unchanged from the original.
      .addCase(flightTimeLoaded, (state, action) => ({
        ...state,
        selectedCombination: {
          ...state.selectedCombination,
          transport: {
            ...state.selectedCombination.transport,
            flightTimeInformation: action.payload,
          },
        },
      }))
      .addCase(addToCartStarted, (state) => {
        state.loadingAddToCart = true;
      })
      .addCase(addToCartFailed, (state) => {
        state.loadingAddToCart = false;
      })
      .addCase(addToCartSucceeded, (state) => {
        state.loadingAddToCart = false;
      });
  },
});

export default comboSummarySlice.reducer;
